import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, LogOut } from "lucide-react";
import { Logo } from "./Brand";
import { useAuth } from "../context/AuthContext";

const NAV = [
  { to: "/lobby", label: "Transmissão Ao Vivo", testid: "nav-lobby" },
  { to: "/edicoes", label: "Edições Anteriores", testid: "nav-edicoes" },
  { to: "/certificado", label: "Certificado", testid: "nav-certificado" },
  { to: "/perfil", label: "Meu Perfil", testid: "nav-perfil" },
];

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  const linkCls = ({ isActive }) =>
    `px-3 py-2 rounded-md text-sm font-semibold transition-colors ${
      isActive ? "text-[#00C8FF] bg-[#142361]" : "text-slate-300 hover:text-white hover:bg-white/5"
    }`;

  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-md bg-[#0C1530]/90 border-b border-[#00C8FF]/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">
        <Link to="/lobby"><Logo /></Link>
        <nav className="hidden md:flex items-center gap-1">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} className={linkCls} data-testid={n.testid}>{n.label}</NavLink>
          ))}
          {user?.role === "admin" && (
            <NavLink to="/admin" className={linkCls} data-testid="nav-admin">Painel Admin</NavLink>
          )}
          <button onClick={handleLogout} data-testid="logout-button"
            className="ml-2 inline-flex items-center gap-1.5 text-sm text-slate-400 hover:text-white px-3 py-2 rounded-md hover:bg-white/5 transition-colors">
            <LogOut size={15} /> Sair
          </button>
        </nav>
        <button className="md:hidden text-white p-2" onClick={() => setOpen(!open)} data-testid="mobile-menu-button" aria-label="Menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <nav className="md:hidden border-t border-[#00C8FF]/20 bg-[#0C1530] px-4 py-3 flex flex-col gap-1" data-testid="mobile-menu">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} onClick={() => setOpen(false)} className={linkCls} data-testid={`mobile-${n.testid}`}>{n.label}</NavLink>
          ))}
          {user?.role === "admin" && (
            <NavLink to="/admin" onClick={() => setOpen(false)} className={linkCls} data-testid="mobile-nav-admin">Painel Admin</NavLink>
          )}
          <button onClick={handleLogout} data-testid="mobile-logout-button"
            className="text-left inline-flex items-center gap-1.5 text-sm text-slate-400 hover:text-white px-3 py-2 rounded-md hover:bg-white/5">
            <LogOut size={15} /> Sair
          </button>
        </nav>
      )}
    </header>
  );
}
